import {AjaxAdd} from '../ajax-add';

import {ProductForm} from '../product-form';
import '../product-form/product-form.pcss';

import {LowStock} from '../low-stock';
import '../low-stock/low-stock.pcss';

import {ModalTrigger} from '../modal/modal-trigger';

import {GalleryFullscreen} from '../gallery-fullscreen';
import {mountReact} from '../../utils';
import {VideoPlayer} from '../video-player';
import {AddedDrawer} from '../added-drawer';
import product from 'ramda/es/product';

const options = {
  jsonSelector: '[data-product-json]'
}

const BaseProduct = {
  onLoad() {
    this.childConfig = {
      namespace: `.${this.id}`,
    };

    this.init();
  },

  init() {
    const productData = this.getProductData();
    const productForm = this.container.querySelector('[data-product-form]');
    this.ProductForm = new ProductForm(productForm, {
      productData
    });

    const sizeGuideLink = this.container.querySelector('[data-size-guide-link]');

    if (sizeGuideLink && sizeGuideLink.getAttribute("href")) {
      this.sizeGuideModalTrigger = new ModalTrigger(
        sizeGuideLink,
        {
          containsExternalStylesheet: true,
          url: sizeGuideLink.getAttribute("href"),
          targetElementSelector: '[data-region*="main"]'
        },
        {
          class: 'size-guide-modal',
          shouldCache: true,
        }
      );
    }

    this.LowStock = new LowStock(this.container);
    this.AjaxAdd = new AjaxAdd(this.container);
    this.galleryFullscreen = new GalleryFullscreen(
      this.container,
      this.childConfig,
    );

    mountReact('#video-player', VideoPlayer);
    mountReact('#added-drawer', AddedDrawer);

    this.checkGiftVoucher();
  },

  getProductData() {
    const jsonElement = this.container.querySelector(options.jsonSelector);

    if (!jsonElement) {
      return;
    }

    const json = jsonElement.innerHTML;

    try {
      return JSON.parse(json);
    } catch (exception) {
      return;
    }
  },

  checkGiftVoucher() {
    const productContainer = document.querySelector('[data-product-type]');
    if (productContainer.dataset.productType === 'gift-vouchers') {
      document.addEventListener('readystatechange', function() {
        if (document.readyState === 'complete' && window.GlobalE.Country !== undefined && window.GlobalE.Country !== 'GB') {
          productContainer.querySelector('.product__add').disabled = 'disabled';
          productContainer.querySelector('.product-unavailable').classList.remove('hidden');
        }
      });
    }
  }
};

export default BaseProduct;
